import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';
import { useEffect } from 'react';

const DynamicRecommendProductList = dynamic(import('./recommend-list'), { ssr: false });

const RecommendList = props => {
  const { ref: viewRef, show, handleShow } = useLazyData({
    threshold: 0.01,
    rootMargin: '15px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  useEffect(() => {
    if (+(sessionStorage.getItem(`memory-cache-${location.pathname}`) || 0) > 0) {
      handleShow();
    }
  }, []);

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicRecommendProductList {...props} skeleton={skeleton} />;
};

export default RecommendList;
